import { UAPPlacementTypeAlias as PT } from '../ad-preview-model';
import {
  // MMA
  AdPlacementMmaLandscapeImage191x100,
  AdPlacementMmaSquareImage1x1,
  AdPlacementMmaVerticalImage1x2,
  AdPlacementMmaWideImage4x1,

  // MMA in MSAN
  AdPlacementMmaInMsanWideImage191x100,
  AdPlacementMmaInMsanSquareImage1x1,
  AdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  AdPlacementMmaInMsanMSNInArticle150x100,
  AdPlacementMmaInMsanMSNSmallHeadline133x100,

  // MMA in MSAN V2
  AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100,
  AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,
  AdPlacementMmaInMsanV2MSANBanner2x1,
  AdPlacementMmaInMsanV2MSANRiver191x100,
  AdPlacementMmaInMsanV2MSANRectangle191x100,
  AdPlacementMmaInMsanV2MSANRectangle120x100,
  AdPlacementMmaInMsanV2MSNCarousel169x100,
  AdPlacementMmaInMsanV2MSNPartnerStripe153x100,
  AdPlacementMmaInMsanV2MSNRestoday124x100,

  // Image Extension
  AdPlacementImgExtWideImage191x100,
  AdPlacementImgExtMSEdgeSingleCarousel178x100,
  AdPlacementImgExtBingDesktopSingleImage178x100,
  AdPlacementImgExtMSEdgeMediumHeadline172x100,
  AdPlacementImgExtMSNSingleCarousel169x100,
  AdPlacementImgExtMSNMediumHeadline155x100,
  AdPlacementImgExtMSNInArticle150x100,
  AdPlacementImgExtMSNSmallHeadline133x100,
  AdPlacementImgExtBingDesktopMultiImage133x100,
  AdPlacementImgExtBingMobileMultiImage133x100,
  AdPlacementImgExtSquareImage1x1,
  AdPlacementImgExtMSNDoubleCarousel93x100,

  //
  AdPlacementBingSearchText,
  AdPlacementBingSearchTextDesktop,
  AdPlacementBingSearchTextMobile,
  AdPlacementOutlookMobile,
  AdPlacementOutlookWeb,

  // Responsive
  ResponsiveAdPlacementMmaLandscapeImage191x100,
  ResponsiveAdPlacementMmaSquareImage1x1,
  ResponsiveAdPlacementMmaVerticalImage1x2,
  ResponsiveAdPlacementMmaWideImage4x1,
  ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  ResponsiveAdPlacementMmaInMsanMSNInArticle150x100,
  ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100,
  ResponsiveAdPlacementMmaInMsanSquareImage1x1,
  ResponsiveAdPlacementMmaInMsanWideImage191x100,
  ResponsiveAdPlacementBingSearchText,
  ResponsiveAdPlacementOutlookMobile,
  ResponsiveAdPlacementOutlookWeb,
  ResponsiveAdPlacementBoostWindowsSpotlight191x100,
  ResponsiveAdPlacementBoostDiscoverCard1x1,
  ResponsiveAdPlacementBoostProngFeed191x100,
  ResponsiveAdPlacementBoostCoachmark175x100,
  ResponsiveAdPlacementBoostStartMenu,
  ResponsiveAdPlacementBoostActionCenter,
  ResponsiveAdPlacementBoostBanner,
  ResponsiveAdPlacementBoostMiniSpotlight,
  ResponsiveAdPlacementBoostContentHub,

  // Responsive Search Ad
  AdPlacementResponsiveSearch,
  AdPlacementResponsiveSearchDesktop,
  AdPlacementResponsiveSearchMobile,

  // Dynamic Search Ad
  AdPlacementDynamicSearch,

  // boost
  AdPlacementBoostHeroImageCarousel,
  AdPlacementBoostWindowsSpotlight191x100,
  AdPlacementBoostDiscoverCard1x1,
  AdPlacementBoostStartMenu,
  AdPlacementBoostActionCenter,
  AdPlacementBoostBanner,
  AdPlacementBoostProngFeed191x100,
  AdPlacementBoostCoachmark175x100,

  // LinkedIn
  AdPlacementLinkedInSingleImageDesktop,
  AdPlacementLinkedInSingleImageMobile,

  // Unified App Ads
  AppAdsVideoHorizontalPlacement,
  AppAdsBingSearchPlacement,
  AppAdsBingSearchPlacementText,
  AppAdsCasualGamesDimensionsPlacement,
  AppAdsM365OutlookPlacement,
  AppAdsMSNDisplayPlacement,

  VideoPlacement,

  // pmax
  AdPlacementPMaxMicrosoftEdgeCarousel201x100,
  AdPlacementPMaxMSNCarousel169x100
} from '../ad-placement-components';

const PlacementType2Component = {
  // MMA
  [PT.MMA.WideImage]: AdPlacementMmaWideImage4x1,
  [PT.MMA.LandscapeImage]: AdPlacementMmaLandscapeImage191x100,
  [PT.MMA.SquareImage]: AdPlacementMmaSquareImage1x1,
  [PT.MMA.VerticalImage]: AdPlacementMmaVerticalImage1x2,

  // MMA in MSAN (Audience Network)
  [PT.MSAN.WideImage]: AdPlacementMmaInMsanWideImage191x100,
  [PT.MSAN.SquareImage]: AdPlacementMmaInMsanSquareImage1x1,
  [PT.MSAN.MSEdgeSingleCarousel]: AdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  [PT.MSAN.MSNInArticle]: AdPlacementMmaInMsanMSNInArticle150x100,
  [PT.MSAN.MSNSmallHeadline]: AdPlacementMmaInMsanMSNSmallHeadline133x100,

  [PT.MSANV2.MSEdgeCarousel]: AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100,
  [PT.MSANV2.MSEdgeMobile]: AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,
  [PT.MSANV2.MSANBanner]: AdPlacementMmaInMsanV2MSANBanner2x1,
  [PT.MSANV2.MSANRiver]: AdPlacementMmaInMsanV2MSANRiver191x100,
  [PT.MSANV2.MSANRectangle]: AdPlacementMmaInMsanV2MSANRectangle120x100,
  [PT.MSANV2.MSANRectangleImage]: AdPlacementMmaInMsanV2MSANRectangle191x100,
  [PT.MSANV2.MSNCarousel]: AdPlacementMmaInMsanV2MSNCarousel169x100,
  [PT.MSANV2.MSNPartnerStripe]: AdPlacementMmaInMsanV2MSNPartnerStripe153x100,
  [PT.MSANV2.MSNRestoday]: AdPlacementMmaInMsanV2MSNRestoday124x100,

  // pmax
  [PT.PMax.AudienceSquareImage]: AdPlacementMmaInMsanSquareImage1x1,
  [PT.PMax.AudienceWideImage]: AdPlacementMmaInMsanWideImage191x100,
  [PT.PMax.MMALandscapeImage]: AdPlacementMmaLandscapeImage191x100,
  [PT.PMax.MMAVerticalImage]: AdPlacementMmaVerticalImage1x2,
  [PT.PMax.MMAWideImage]: AdPlacementMmaWideImage4x1,
  [PT.PMax.MSNInArticle]: AdPlacementMmaInMsanMSNInArticle150x100,
  [PT.PMax.MSNSmallHeadline]: AdPlacementMmaInMsanMSNSmallHeadline133x100,
  [PT.PMax.MSEdgeSingleCarousel]: AdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  [PT.PMax.MMAV2MSEdgeCarousel]: AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100,
  [PT.PMax.MMAV2MSNSingleCarousel]: AdPlacementMmaInMsanV2MSNCarousel169x100,
  [PT.PMax.MMAV2MSNRestoday]: AdPlacementMmaInMsanV2MSNRestoday124x100,
  [PT.PMax.MMAV2MSNPartnerStripe]: AdPlacementMmaInMsanV2MSNPartnerStripe153x100,
  [PT.PMax.MMAV2MSNRiver]: AdPlacementMmaInMsanV2MSANRiver191x100,
  [PT.PMax.Video]: VideoPlacement,
  [PT.PMax.MSEdgeMobile]: AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,

  // Image Extension
  [PT.ImageExt.WideImage]: AdPlacementImgExtWideImage191x100,
  [PT.ImageExt.MSEdgeSingleCarousel]: AdPlacementImgExtMSEdgeSingleCarousel178x100,
  [PT.ImageExt.BingDesktopSingleImage]: AdPlacementImgExtBingDesktopSingleImage178x100,
  [PT.ImageExt.MSEdgeMediumHeadline]: AdPlacementImgExtMSEdgeMediumHeadline172x100,
  [PT.ImageExt.MSNSingleCarousel]: AdPlacementImgExtMSNSingleCarousel169x100,
  [PT.ImageExt.MSNMediumHeadline]: AdPlacementImgExtMSNMediumHeadline155x100,
  [PT.ImageExt.MSNInArticle]: AdPlacementImgExtMSNInArticle150x100,
  [PT.ImageExt.MSNSmallHeadline]: AdPlacementImgExtMSNSmallHeadline133x100,
  [PT.ImageExt.BingDesktopMultiImage]: AdPlacementImgExtBingDesktopMultiImage133x100,
  [PT.ImageExt.BingMobileMultiImage]: AdPlacementImgExtBingMobileMultiImage133x100,
  [PT.ImageExt.SquareImage]: AdPlacementImgExtSquareImage1x1,
  [PT.ImageExt.MSNDoubleCarousel]: AdPlacementImgExtMSNDoubleCarousel93x100,
  [PT.ImageExt.MMAV2MSNRiver]: AdPlacementMmaInMsanV2MSANRiver191x100,
  [PT.ImageExt.MMAV2MSNSingleCarousel]: AdPlacementMmaInMsanV2MSNCarousel169x100,
  [PT.ImageExt.MSEdgeMobile]: AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,

  //
  [PT.Outlook.Mobile]: AdPlacementOutlookMobile,
  [PT.Outlook.Web]: AdPlacementOutlookWeb,
  [PT.BingSearch.Mobile]: AdPlacementBingSearchTextMobile,
  [PT.BingSearch.Desktop]: AdPlacementBingSearchTextDesktop,
  [PT.BingSearch.Text]: AdPlacementBingSearchText,

  // responsive MMA
  [PT.Responsive.MMA.WideImage]: ResponsiveAdPlacementMmaWideImage4x1,
  [PT.Responsive.MMA.LandscapeImage]: ResponsiveAdPlacementMmaLandscapeImage191x100,
  [PT.Responsive.MMA.SquareImage]: ResponsiveAdPlacementMmaSquareImage1x1,
  [PT.Responsive.MMA.VerticalImage]: ResponsiveAdPlacementMmaVerticalImage1x2,

  // responsive MMA in MSAN (Audience Network)
  [PT.Responsive.MSAN.WideImage]: ResponsiveAdPlacementMmaInMsanWideImage191x100,
  [PT.Responsive.MSAN.SquareImage]: ResponsiveAdPlacementMmaInMsanSquareImage1x1,
  [PT.Responsive.MSAN.MSEdgeSingleCarousel]: ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  [PT.Responsive.MSAN.MSNInArticle]: ResponsiveAdPlacementMmaInMsanMSNInArticle150x100,
  [PT.Responsive.MSAN.MSNSmallHeadline]: ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100,

  [PT.Responsive.MSANV2.MSEdgeCarousel]: AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100,
  [PT.Responsive.MSANV2.MSEdgeMobile]: AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,
  [PT.Responsive.MSANV2.MSANBanner]: AdPlacementMmaInMsanV2MSANBanner2x1,
  [PT.Responsive.MSANV2.MSANRiver]: AdPlacementMmaInMsanV2MSANRiver191x100,
  [PT.Responsive.MSANV2.MSANRectangle]: AdPlacementMmaInMsanV2MSANRectangle120x100,
  [PT.Responsive.MSANV2.MSANRectangleImage]: AdPlacementMmaInMsanV2MSANRectangle191x100,
  [PT.Responsive.MSANV2.MSNCarousel]: AdPlacementMmaInMsanV2MSNCarousel169x100,
  [PT.Responsive.MSANV2.MSNPartnerStripe]: AdPlacementMmaInMsanV2MSNPartnerStripe153x100,
  [PT.Responsive.MSANV2.MSNRestoday]: AdPlacementMmaInMsanV2MSNRestoday124x100,

  // responsive text
  [PT.Responsive.Outlook.Mobile]: ResponsiveAdPlacementOutlookMobile,
  [PT.Responsive.Outlook.Web]: ResponsiveAdPlacementOutlookWeb,
  [PT.Responsive.BingSearch.Text]: ResponsiveAdPlacementBingSearchText,

  // dynamic search ad
  [PT.DynamicSearch.Dynamic]: AdPlacementDynamicSearch,

  // responsive search ad
  [PT.ResponsiveSearch.Text]: AdPlacementResponsiveSearch,
  [PT.ResponsiveSearch.Desktop]: AdPlacementResponsiveSearchDesktop,
  [PT.ResponsiveSearch.Mobile]: AdPlacementResponsiveSearchMobile,

  // responsive boost
  [PT.Responsive.Boost.WindowsSpotlight]: ResponsiveAdPlacementBoostWindowsSpotlight191x100,
  [PT.Responsive.Boost.DiscoverCard]: ResponsiveAdPlacementBoostDiscoverCard1x1,
  [PT.Responsive.Boost.StartMenu]: ResponsiveAdPlacementBoostStartMenu,
  [PT.Responsive.Boost.ActionCenter]: ResponsiveAdPlacementBoostActionCenter,
  [PT.Responsive.Boost.Banner]: ResponsiveAdPlacementBoostBanner,
  [PT.Responsive.Boost.Prong1Prong2Feed]: ResponsiveAdPlacementBoostProngFeed191x100,
  [PT.Responsive.Boost.Coachmark]: ResponsiveAdPlacementBoostCoachmark175x100,
  [PT.Responsive.Boost.MiniSpotlight]: ResponsiveAdPlacementBoostMiniSpotlight,
  [PT.Responsive.Boost.ContentHub]: ResponsiveAdPlacementBoostContentHub,

  // responsive pmax
  [PT.Responsive.PMax.AudienceSquareImage]: ResponsiveAdPlacementMmaInMsanSquareImage1x1,
  [PT.Responsive.PMax.AudienceWideImage]: ResponsiveAdPlacementMmaInMsanWideImage191x100,
  [PT.Responsive.PMax.MMALandscapeImage]: ResponsiveAdPlacementMmaLandscapeImage191x100,
  [PT.Responsive.PMax.MMAVerticalImage]: ResponsiveAdPlacementMmaVerticalImage1x2,
  [PT.Responsive.PMax.MMAWideImage]: ResponsiveAdPlacementMmaWideImage4x1,
  [PT.Responsive.PMax.MSNInArticle]: ResponsiveAdPlacementMmaInMsanMSNInArticle150x100,
  [PT.Responsive.PMax.MSNSmallHeadline]: ResponsiveAdPlacementMmaInMsanMSNSmallHeadline133x100,
  [PT.Responsive.PMax.MSEdgeSingleCarousel]: ResponsiveAdPlacementMmaInMsanMSEdgeSingleCarousel178x100,
  [PT.Responsive.PMax.MMAV2MSEdgeCarousel]: AdPlacementPMaxMicrosoftEdgeCarousel201x100,
  [PT.Responsive.PMax.MMAV2MSNSingleCarousel]: AdPlacementPMaxMSNCarousel169x100,
  [PT.Responsive.PMax.MMAV2MSNRestoday]: AdPlacementMmaInMsanV2MSNRestoday124x100,
  [PT.Responsive.PMax.MMAV2MSNPartnerStripe]: AdPlacementMmaInMsanV2MSNPartnerStripe153x100,
  [PT.Responsive.PMax.MMAV2MSNRiver]: AdPlacementMmaInMsanV2MSANRiver191x100,
  [PT.Responsive.PMax.MSEdgeMobile]: AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1,

  // Boost
  [PT.Boost.HeroImageCarousel200x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel122x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel159x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel180x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel233x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel320x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.HeroImageCarousel57x100]: AdPlacementBoostHeroImageCarousel,
  [PT.Boost.WindowsSpotlight]: AdPlacementBoostWindowsSpotlight191x100,
  [PT.Boost.DiscoverCard]: AdPlacementBoostDiscoverCard1x1,
  [PT.Boost.StartMenu]: AdPlacementBoostStartMenu,
  [PT.Boost.ActionCenter]: AdPlacementBoostActionCenter,
  [PT.Boost.Banner]: AdPlacementBoostBanner,
  [PT.Boost.Prong1Prong2Feed]: AdPlacementBoostProngFeed191x100,
  [PT.Boost.Coachmark]: AdPlacementBoostCoachmark175x100,

  // LinkedIn
  [PT.LinkedIn.Landscape.SingleImageDesktop]: AdPlacementLinkedInSingleImageDesktop,
  [PT.LinkedIn.Landscape.SingleImageMobile]: AdPlacementLinkedInSingleImageMobile,

  [PT.LinkedIn.Square.SingleImageDesktop]: AdPlacementLinkedInSingleImageDesktop,
  [PT.LinkedIn.Square.SingleImageMobile]: AdPlacementLinkedInSingleImageMobile,

  [PT.LinkedIn.Vertical.SingleImageMobile]: AdPlacementLinkedInSingleImageMobile,

  // Unified App Ads
  [PT.UnifiedAppAds.VideoHorizontal]: AppAdsVideoHorizontalPlacement,
  [PT.UnifiedAppAds.BingSearch]: AppAdsBingSearchPlacement,
  [PT.UnifiedAppAds.BingSearchText]: AppAdsBingSearchPlacementText,
  [PT.UnifiedAppAds.CasualGamesDimensions]: AppAdsCasualGamesDimensionsPlacement,
  [PT.UnifiedAppAds.M365Outlook]: AppAdsM365OutlookPlacement,
  [PT.UnifiedAppAds.MSNDisplay]: AppAdsMSNDisplayPlacement,
};

export const getAdPlacementComponent = placementType => PlacementType2Component[placementType];
